// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-button {
  padding-top: 30px;
  width: 100%;
}
.add-button ion-label {
  font-weight: bold;
}

.loyalty-label {
  align-self: center;
  padding-top: 30px;
}

.checkboxes-wrapper ion-checkbox {
  margin: 9px 8px 9px 0px !important;
}
.checkboxes-wrapper ion-list {
  padding-left: 5px !important;
}

.checkbox-link .checkbox-label {
  font-size: 0.8rem;
  font-weight: 500;
}

.input-group {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.input-group ion-label {
  max-width: 300px;
}

.main-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.title {
  align-self: center;
  font-size: large;
}

ion-item {
  width: 100%;
}

.page-content {
  height: 100vh;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/loyalty-program/loyalty-program.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,WAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,kBAAA;EACA,iBAAA;AAAF;;AAIE;EACE,kCAAA;AADJ;AAGE;EACE,4BAAA;AADJ;;AAME;EACE,iBAAA;EACA,gBAAA;AAHJ;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;AALF;AAME;EACE,gBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;AALF;;AAQA;EACE,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,aAAA;EACA,gBAAA;AALF","sourcesContent":[".add-button {\n  padding-top: 30px;\n  width: 100%;\n\n  ion-label {\n    font-weight: bold;\n  }\n}\n\n.loyalty-label {\n  align-self: center;\n  padding-top: 30px;\n}\n\n.checkboxes-wrapper {\n  ion-checkbox {\n    margin: 9px 8px 9px 0px!important;\n  }\n  ion-list {\n    padding-left: 5px!important;\n  }\n}\n\n.checkbox-link {\n  .checkbox-label {\n    font-size: 0.8rem;\n    font-weight: 500;\n  }\n}\n\n\n.input-group {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  ion-label {\n    max-width: 300px;\n  }\n}\n\n.main-container {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.title {\n  align-self: center;\n  font-size: large;\n}\n\nion-item {\n  width: 100%;\n}\n\n.page-content {\n  height: 100vh; // Adjust based on your navbar height\n  overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
